import ClickOutside from 'vuetify/lib/directives/click-outside';

import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    staticClass: "card card-custom gutter-b"
  }, [_c('div', {
    staticClass: "card-header card-header-tabs-line"
  }, [_c('ul', {
    ref: "builder-tab",
    staticClass: "nav nav-dark nav-bold nav-tabs nav-tabs-line",
    attrs: {
      "role": "tablist"
    }
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "data-tab": "0",
      "data-toggle": "tab",
      "href": "#",
      "role": "tab"
    },
    on: {
      "click": _vm.setActiveTab
    }
  }, [_vm._v(" Importar OFX ")])]), _vm.transacoes.length > 0 ? _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    class: {
      disabled: !_vm.form.id_banco
    },
    attrs: {
      "data-tab": "1",
      "data-toggle": "tab",
      "href": "#",
      "role": "tab"
    },
    on: {
      "click": _vm.setActiveTab
    }
  }, [_vm._v(" Lançamentos (" + _vm._s(_vm.transacoes.length) + ") ")])]) : _vm._e()])]), _c('div', {
    staticClass: "card-body"
  }, [_c('b-tabs', {
    staticClass: "hide-tabs",
    model: {
      value: _vm.tabIndex,
      callback: function callback($$v) {
        _vm.tabIndex = $$v;
      },
      expression: "tabIndex"
    }
  }, [_c('b-tab', {
    attrs: {
      "active": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Conta Bancária",
      "label-for": "banco_busca"
    }
  }, [_c('div', {
    directives: [{
      def: ClickOutside,
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.fecharDropdownBanco,
      expression: "fecharDropdownBanco"
    }],
    staticClass: "banco-typeahead"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('b-form-input', {
    attrs: {
      "id": "banco_busca",
      "autocomplete": "off",
      "placeholder": "Digite para buscar a conta bancária...",
      "state": _vm.form.id_banco ? true : _vm.bancoBusca && !_vm.form.id_banco ? false : null
    },
    on: {
      "input": _vm.onBancoBuscaInput,
      "focus": function focus($event) {
        _vm.bancoDropdownAberto = true;
      }
    },
    model: {
      value: _vm.bancoBusca,
      callback: function callback($$v) {
        _vm.bancoBusca = $$v;
      },
      expression: "bancoBusca"
    }
  }), _vm.form.id_banco ? _c('div', {
    staticClass: "input-group-append"
  }, [_c('button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      value: 'Limpar seleção',
      expression: "'Limpar seleção'",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "btn btn-outline-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.limparBanco
    }
  }, [_vm._v("✕")])]) : _vm._e()], 1), _c('b-form-invalid-feedback', {
    attrs: {
      "state": _vm.form.id_banco ? true : _vm.bancoBusca && !_vm.form.id_banco ? false : null
    }
  }, [_vm._v(" Selecione uma conta bancária válida da lista. ")]), _vm.bancoDropdownAberto && _vm.bancos.length > 0 ? _c('div', {
    staticClass: "banco-typeahead__dropdown"
  }, _vm._l(_vm.bancos, function (b) {
    return _c('div', {
      key: b.id_banco,
      staticClass: "banco-typeahead__option",
      on: {
        "mousedown": function mousedown($event) {
          $event.preventDefault();
          return _vm.selecionarBanco(b);
        }
      }
    }, [_c('span', {
      staticClass: "font-weight-bold"
    }, [_vm._v(_vm._s(b.nome))]), _c('small', {
      staticClass: "text-muted ml-2"
    }, [_vm._v("Ag: " + _vm._s(b.agencia) + " / Cc: " + _vm._s(b.conta))])]);
  }), 0) : _vm._e(), _vm.bancoDropdownAberto && _vm.bancoBusca && _vm.bancos.length === 0 ? _c('div', {
    staticClass: "banco-typeahead__dropdown"
  }, [_c('div', {
    staticClass: "banco-typeahead__empty"
  }, [_vm._v("Nenhuma conta encontrada.")])]) : _vm._e()], 1)])], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "ofx-dropzone",
    class: {
      'ofx-dropzone--active': _vm.isDragging
    },
    on: {
      "dragover": function dragover($event) {
        $event.preventDefault();
        _vm.isDragging = true;
      },
      "dragleave": function dragleave($event) {
        $event.preventDefault();
        _vm.isDragging = false;
      },
      "drop": function drop($event) {
        $event.preventDefault();
        return _vm.onFileDrop.apply(null, arguments);
      },
      "click": function click($event) {
        return _vm.$refs.fileInput.click();
      }
    }
  }, [_c('input', {
    ref: "fileInput",
    attrs: {
      "type": "file",
      "accept": ".ofx,.OFX",
      "hidden": ""
    },
    on: {
      "change": _vm.onFileChange
    }
  }), !_vm.arquivoNome ? _c('div', {
    staticClass: "text-center text-muted"
  }, [_c('FileUpload', {
    staticClass: "mb-2",
    attrs: {
      "size": 40
    }
  }), _c('p', {
    staticClass: "mb-0 font-weight-bold"
  }, [_vm._v(" Clique ou arraste o arquivo OFX aqui ")]), _c('small', [_vm._v("Formatos aceitos: .ofx")])], 1) : _c('div', {
    staticClass: "text-center"
  }, [_c('FileCheck', {
    staticClass: "mb-2 text-success",
    attrs: {
      "size": 40
    }
  }), _c('p', {
    staticClass: "mb-0 font-weight-bold text-success"
  }, [_vm._v(" " + _vm._s(_vm.arquivoNome) + " ")]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" Clique para trocar o arquivo ")])], 1)])])], 1), _vm.ofxResumo ? _c('b-row', {
    staticClass: "mt-4"
  }, [_c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('b-card', {
    staticClass: "border"
  }, [_c('h6', {
    staticClass: "font-weight-bold mb-3"
  }, [_vm._v(" Resumo do arquivo OFX ")]), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('small', {
    staticClass: "text-muted d-block"
  }, [_vm._v("Banco (OFX)")]), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.ofxResumo.bankId || "-") + " ")])]), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('small', {
    staticClass: "text-muted d-block"
  }, [_vm._v("Conta (OFX)")]), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.ofxResumo.acctId || "-") + " ")])]), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('small', {
    staticClass: "text-muted d-block"
  }, [_vm._v(" Total de lançamentos ")]), _c('span', {
    staticClass: "font-weight-bold text-primary"
  }, [_vm._v(" " + _vm._s(_vm.transacoes.length) + " ")])]), _c('b-col', {
    staticClass: "mt-3",
    attrs: {
      "md": "4"
    }
  }, [_c('small', {
    staticClass: "text-muted d-block"
  }, [_vm._v("Data início")]), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.ofxResumo.dtStart || "-") + " ")])]), _c('b-col', {
    staticClass: "mt-3",
    attrs: {
      "md": "4"
    }
  }, [_c('small', {
    staticClass: "text-muted d-block"
  }, [_vm._v("Data fim")]), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.ofxResumo.dtEnd || "-") + " ")])]), _c('b-col', {
    staticClass: "mt-3",
    attrs: {
      "md": "4"
    }
  }, [_c('small', {
    staticClass: "text-muted d-block"
  }, [_vm._v("Saldo final")]), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" R$ " + _vm._s(_vm.numberToReal(_vm.ofxResumo.ledgerBal || 0, 2)) + " ")])])], 1)], 1)], 1)], 1) : _vm._e(), _vm.transacoes.length > 0 ? _c('b-row', {
    staticClass: "mt-4"
  }, [_c('b-col', [_c('button', {
    staticClass: "btn btn-info font-weight-bold mr-2",
    on: {
      "click": _vm.avancarParaLancamentos
    }
  }, [_vm._v(" Ver lançamentos ")])])], 1) : _vm._e()], 1), _c('b-tab', [_c('div', {
    staticClass: "d-flex align-items-center justify-content-between mb-3 flex-wrap",
    staticStyle: {
      "gap": "12px"
    }
  }, [_c('div', {
    staticStyle: {
      "min-width": "260px",
      "flex": "1"
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-between mb-1"
  }, [_c('small', {
    staticClass: "text-muted font-weight-bold"
  }, [_vm._v("Progresso de conciliação")]), _c('small', {
    staticClass: "font-weight-bold",
    class: _vm.getTextVariant(_vm.percentualConcluido)
  }, [_vm._v(" " + _vm._s(_vm.conciliadosCount) + " / " + _vm._s(_vm.transacoes.length) + " — " + _vm._s(_vm.percentualConcluido) + "% ")])]), _c('b-progress', {
    attrs: {
      "value": _vm.percentualConcluido,
      "max": 100,
      "variant": _vm.getProgressVariant(_vm.percentualConcluido),
      "height": "12px",
      "show-progress": ""
    }
  })], 1), _c('div', {
    staticClass: "d-flex align-items-center",
    staticStyle: {
      "gap": "8px"
    }
  }, [_c('b-form-input', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "placeholder": "Buscar...",
      "size": "sm"
    },
    model: {
      value: _vm.buscaLancamento,
      callback: function callback($$v) {
        _vm.buscaLancamento = $$v;
      },
      expression: "buscaLancamento"
    }
  }), _c('b-form-select', {
    staticStyle: {
      "width": "130px"
    },
    attrs: {
      "size": "sm"
    },
    model: {
      value: _vm.filtroLancamento,
      callback: function callback($$v) {
        _vm.filtroLancamento = $$v;
      },
      expression: "filtroLancamento"
    }
  }, [_c('b-form-select-option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Todos OFX")]), _c('b-form-select-option', {
    attrs: {
      "value": "pendente"
    }
  }, [_vm._v("Pendentes")]), _c('b-form-select-option', {
    attrs: {
      "value": "conciliado"
    }
  }, [_vm._v("Conciliados")]), _c('b-form-select-option', {
    attrs: {
      "value": "ignorado"
    }
  }, [_vm._v("Ignorados")])], 1), _c('button', {
    staticClass: "btn btn-primary font-weight-bold btn-sm",
    attrs: {
      "disabled": _vm.isSaving
    },
    on: {
      "click": _vm.salvarConciliacao
    }
  }, [_vm.isSaving ? _c('b-spinner', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" Salvar Conciliação ")], 1)], 1)]), _c('div', {
    staticClass: "conciliacao-grid"
  }, [_c('div', {
    staticClass: "conc-col"
  }, [_c('div', {
    staticClass: "conc-col-header conc-col-header--ofx"
  }, [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Extrato OFX")]), _c('span', {
    staticClass: "badge badge-light ml-2"
  }, [_vm._v(_vm._s(_vm.lancamentosOFXPendentes.length) + " pendentes")])]), _vm.lancamentosSelecionaveisEmMassa.length > 0 ? _c('div', {
    staticClass: "lancamentos-massa-toolbar"
  }, [_c('b-form-checkbox', {
    attrs: {
      "checked": _vm.todosLancamentosVisiveisSelecionadosEmMassa
    },
    on: {
      "change": _vm.alternarTodosLancamentosEmMassa
    }
  }, [_vm._v(" Selecionar compatíveis ")]), _c('button', {
    staticClass: "btn btn-sm btn-light-primary font-weight-bold",
    attrs: {
      "type": "button",
      "disabled": _vm.fitIdsSelecionadosEmMassa.length === 0
    },
    on: {
      "click": _vm.abrirModalLancamentosEmMassa
    }
  }, [_c('PlusCircle', {
    staticClass: "mr-1",
    attrs: {
      "size": 14
    }
  }), _vm._v(" Lançar em massa (" + _vm._s(_vm.fitIdsSelecionadosEmMassa.length) + ") ")], 1)], 1) : _vm._e(), _c('div', {
    staticClass: "conc-col-body"
  }, [_vm.lancamentosOFXPendentes.length === 0 ? _c('div', {
    staticClass: "text-center text-muted py-5"
  }, [_c('Check', {
    staticClass: "text-success mb-2",
    attrs: {
      "size": 32
    }
  }), _c('p', {
    staticClass: "mb-0"
  }, [_vm._v("Todos conciliados!")])], 1) : _vm._e(), _vm._l(_vm.lancamentosOFXPendentesVisiveis, function (trn, idx) {
    return _c('div', {
      key: 'ofx-' + (trn.fitId || idx),
      staticClass: "ofx-card",
      class: {
        'ofx-card--dragging': _vm.draggedOfx === trn,
        'ofx-card--sugerido': trn._sugeridoSistema
      },
      attrs: {
        "draggable": "true"
      },
      on: {
        "dragstart": function dragstart($event) {
          return _vm.onDragStart(trn, $event);
        },
        "dragend": _vm.onDragEnd
      }
    }, [_c('div', {
      staticClass: "d-flex justify-content-between align-items-start"
    }, [_vm.podeSelecionarLancamentoEmMassa(trn) ? _c('b-form-checkbox', {
      staticClass: "ofx-card__selecao mr-2",
      attrs: {
        "checked": _vm.isLancamentoSelecionadoEmMassa(trn)
      },
      on: {
        "change": function change(marcado) {
          return _vm.alternarLancamentoEmMassa(trn, marcado);
        }
      },
      nativeOn: {
        "click": function click($event) {
          $event.stopPropagation();
        },
        "mousedown": function mousedown($event) {
          $event.stopPropagation();
        }
      }
    }) : _vm._e(), _c('div', {
      staticStyle: {
        "flex": "1",
        "min-width": "0"
      }
    }, [_c('div', {
      staticClass: "d-flex align-items-center mb-1",
      staticStyle: {
        "gap": "4px"
      }
    }, [_c('span', {
      class: _vm.getTipoClass(trn.trnType),
      staticStyle: {
        "font-size": "8px",
        "padding": "2px 4px"
      }
    }, [_vm._v(" " + _vm._s(_vm.getTipoLabel(trn.trnType)) + " ")]), _c('small', {
      staticClass: "text-muted",
      staticStyle: {
        "font-size": "9px"
      }
    }, [_vm._v(_vm._s(_vm.formatDate(trn.dtPosted)))]), trn._sugeridoSistema ? _c('span', {
      staticClass: "badge badge-warning",
      staticStyle: {
        "font-size": "7px",
        "padding": "2px 4px"
      }
    }, [_vm._v(" ✓ Sugerido ")]) : _vm._e()]), _c('div', {
      staticClass: "ofx-card__memo"
    }, [_vm._v(_vm._s(trn.memo || "—"))]), _c('small', {
      staticClass: "text-muted",
      staticStyle: {
        "font-size": "8px"
      }
    }, [_vm._v("ID: " + _vm._s(trn.fitId))]), trn._criarMovimentacao ? _c('div', {
      staticClass: "mt-1"
    }, [_c('span', {
      staticClass: "badge badge-info",
      staticStyle: {
        "font-size": "7px",
        "padding": "2px 4px"
      }
    }, [_vm._v("+ Criar lançamento")]), trn._novoLancamento ? _c('span', {
      staticClass: "text-muted ml-1",
      staticStyle: {
        "font-size": "8px"
      }
    }, [_vm._v(_vm._s(trn._novoLancamento.descricao))]) : _vm._e()]) : _vm._e(), trn._sugeridoSistema && trn._sugestaoCompleta ? _c('div', {
      staticClass: "mt-1"
    }, [_c('small', {
      staticClass: "badge badge-light",
      staticStyle: {
        "font-size": "8px"
      }
    }, [_c('strong', [_vm._v("Sistema:")]), _vm._v(" " + _vm._s(trn._sugeridoSistema) + " "), trn._sugestaoCompleta.sistema && trn._sugestaoCompleta.sistema.documento ? _c('span', [_vm._v(" (Doc: " + _vm._s(trn._sugestaoCompleta.sistema.documento) + ") ")]) : _vm._e()])]) : _vm._e()]), _c('div', {
      staticClass: "ml-2 text-right"
    }, [_c('div', {
      staticClass: "font-weight-bolder",
      class: trn.trnAmt >= 0 ? 'text-success' : 'text-danger',
      staticStyle: {
        "font-size": "12px",
        "white-space": "nowrap"
      }
    }, [_vm._v(" R$ " + _vm._s(_vm.numberToReal(Math.abs(trn.trnAmt), 2)) + " ")]), _c('button', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        value: 'Ignorar',
        expression: "'Ignorar'",
        modifiers: {
          "hover": true
        }
      }],
      staticClass: "btn btn-xs btn-link text-muted p-0 mt-1",
      staticStyle: {
        "font-size": "8px"
      },
      on: {
        "click": function click($event) {
          return _vm.marcarIgnorado(trn);
        }
      }
    }, [_vm._v(" Ignorar ")]), !trn._criarMovimentacao && trn.status === 'pendente' ? _c('button', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        value: 'Criar lançamento financeiro',
        expression: "'Criar lançamento financeiro'",
        modifiers: {
          "hover": true
        }
      }],
      staticClass: "btn btn-xs btn-link text-info p-0 mt-1",
      staticStyle: {
        "font-size": "8px"
      },
      on: {
        "click": function click($event) {
          return _vm.abrirModalNovoLancamento(trn);
        }
      }
    }, [_c('PlusCircle', {
      staticClass: "mr-1",
      attrs: {
        "size": 10
      }
    }), _vm._v("Criar ")], 1) : _vm._e(), trn._criarMovimentacao ? _c('button', {
      staticClass: "btn btn-xs btn-link text-danger p-0 mt-1",
      staticStyle: {
        "font-size": "8px"
      },
      on: {
        "click": function click($event) {
          return _vm.cancelarNovoLancamento(trn);
        }
      }
    }, [_vm._v(" ✕ Cancelar criação ")]) : _vm._e()])], 1), _c('div', {
      staticClass: "ofx-card__drag-hint"
    }, [_c('ArrowRight', {
      staticClass: "mr-1",
      attrs: {
        "size": 12
      }
    }), _vm._v("Arraste para conciliar ")], 1)]);
  }), _vm.lancamentosOFXPendentesVisiveis.length < _vm.lancamentosOFXPendentes.length ? _c('button', {
    staticClass: "btn btn-sm btn-light-primary font-weight-bold mt-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.carregarMaisOFX
    }
  }, [_vm._v(" Mostrar mais " + _vm._s(Math.min(_vm.LOTE_RENDERIZACAO, _vm.lancamentosOFXPendentes.length - _vm.lancamentosOFXPendentesVisiveis.length)) + " ")]) : _vm._e(), _vm.transacoesIgnoradas.length > 0 ? _c('div', {
    staticClass: "mt-2"
  }, [_c('div', {
    staticClass: "text-muted font-weight-bold cursor-pointer",
    staticStyle: {
      "font-size": "10px"
    },
    on: {
      "click": function click($event) {
        _vm.showIgnorados = !_vm.showIgnorados;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.showIgnorados ? '▼' : '▶') + " " + _vm._s(_vm.transacoesIgnoradas.length) + " ignorados ")]), _vm.showIgnorados ? _c('div', [_vm._l(_vm.transacoesIgnoradasVisiveis, function (trn, idx) {
    return _c('div', {
      key: 'ign-' + (trn.fitId || idx),
      staticClass: "ofx-card ofx-card--ignored mt-2"
    }, [_c('div', {
      staticClass: "d-flex justify-content-between align-items-center"
    }, [_c('div', [_c('small', {
      staticClass: "text-muted",
      staticStyle: {
        "font-size": "9px"
      }
    }, [_vm._v(_vm._s(_vm.formatDate(trn.dtPosted)))]), _c('div', {
      staticStyle: {
        "font-size": "11px"
      }
    }, [_vm._v(_vm._s(trn.memo))])]), _c('div', {
      staticClass: "d-flex align-items-center",
      staticStyle: {
        "gap": "4px"
      }
    }, [_c('span', {
      staticClass: "text-muted",
      staticStyle: {
        "font-size": "11px"
      }
    }, [_vm._v(" R$ " + _vm._s(_vm.numberToReal(Math.abs(trn.trnAmt), 2)) + " ")]), _c('button', {
      staticClass: "btn btn-xs btn-link p-0 text-warning",
      staticStyle: {
        "font-size": "8px"
      },
      on: {
        "click": function click($event) {
          return _vm.marcarPendente(trn);
        }
      }
    }, [_vm._v("Reativar")])])])]);
  }), _vm.transacoesIgnoradasVisiveis.length < _vm.transacoesIgnoradas.length ? _c('button', {
    staticClass: "btn btn-sm btn-light-secondary font-weight-bold mt-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.carregarMaisIgnorados
    }
  }, [_vm._v(" Mostrar mais " + _vm._s(Math.min(_vm.LOTE_RENDERIZACAO, _vm.transacoesIgnoradas.length - _vm.transacoesIgnoradasVisiveis.length)) + " ")]) : _vm._e()], 2) : _vm._e()]) : _vm._e()], 2)]), _c('div', {
    staticClass: "conc-col"
  }, [_c('div', {
    staticClass: "conc-col-header conc-col-header--sistema"
  }, [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Lançamentos do Sistema")]), _c('span', {
    staticClass: "badge badge-light ml-2"
  }, [_vm._v(_vm._s(_vm.lancamentosSistemaDisponiveis.length) + " disponíveis")]), _c('div', {
    staticClass: "ml-auto d-flex align-items-center",
    staticStyle: {
      "gap": "6px"
    }
  }, [_c('button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      value: _vm.showFiltrosSistema ? 'Ocultar filtros' : 'Mostrar filtros para buscar lançamentos por tipo e período',
      expression: "showFiltrosSistema ? 'Ocultar filtros' : 'Mostrar filtros para buscar lançamentos por tipo e período'",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "btn btn-xs btn-link p-0 text-white",
    on: {
      "click": function click($event) {
        _vm.showFiltrosSistema = !_vm.showFiltrosSistema;
      }
    }
  }, [_c('FilterVariant', {
    attrs: {
      "size": 14
    }
  })], 1), _c('button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      value: 'Recarregar lançamentos do sistema',
      expression: "'Recarregar lançamentos do sistema'",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "btn btn-xs btn-link p-0 text-white",
    attrs: {
      "disabled": _vm.isLoadingSistema
    },
    on: {
      "click": _vm.fetchLancamentosSistema
    }
  }, [_c('Refresh', {
    attrs: {
      "size": 14
    }
  })], 1)])]), _vm.showFiltrosSistema ? _c('div', {
    staticClass: "sistema-filtros"
  }, [_c('div', {
    staticClass: "sistema-filtros__grid"
  }, [_c('div', [_c('label', {
    staticStyle: {
      "font-size": "9px",
      "margin-bottom": "1px",
      "color": "#555"
    }
  }, [_vm._v("Tipo")]), _c('b-form-select', {
    staticStyle: {
      "font-size": "11px"
    },
    attrs: {
      "size": "sm"
    },
    model: {
      value: _vm.filtroSistemaTipo,
      callback: function callback($$v) {
        _vm.filtroSistemaTipo = $$v;
      },
      expression: "filtroSistemaTipo"
    }
  }, [_c('b-form-select-option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Todos")]), _c('b-form-select-option', {
    attrs: {
      "value": "receber"
    }
  }, [_vm._v("A Receber")]), _c('b-form-select-option', {
    attrs: {
      "value": "pagar"
    }
  }, [_vm._v("A Pagar")])], 1)], 1), _c('div', [_c('label', {
    staticStyle: {
      "font-size": "9px",
      "margin-bottom": "1px",
      "color": "#555"
    }
  }, [_vm._v("Situação")]), _c('b-form-select', {
    staticStyle: {
      "font-size": "11px"
    },
    attrs: {
      "size": "sm"
    },
    model: {
      value: _vm.filtroSistemaSituacao,
      callback: function callback($$v) {
        _vm.filtroSistemaSituacao = $$v;
      },
      expression: "filtroSistemaSituacao"
    }
  }, [_c('b-form-select-option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Todas")]), _c('b-form-select-option', {
    attrs: {
      "value": "aberto"
    }
  }, [_vm._v("Em aberto")]), _c('b-form-select-option', {
    attrs: {
      "value": "baixado"
    }
  }, [_vm._v("Baixado")])], 1)], 1), _c('div', [_c('label', {
    staticStyle: {
      "font-size": "9px",
      "margin-bottom": "1px",
      "color": "#555"
    }
  }, [_vm._v("De")]), _c('b-form-input', {
    staticStyle: {
      "font-size": "11px"
    },
    attrs: {
      "type": "date",
      "size": "sm"
    },
    model: {
      value: _vm.filtroSistemaInicio,
      callback: function callback($$v) {
        _vm.filtroSistemaInicio = $$v;
      },
      expression: "filtroSistemaInicio"
    }
  })], 1), _c('div', [_c('label', {
    staticStyle: {
      "font-size": "9px",
      "margin-bottom": "1px",
      "color": "#555"
    }
  }, [_vm._v("Até")]), _c('b-form-input', {
    staticStyle: {
      "font-size": "11px"
    },
    attrs: {
      "type": "date",
      "size": "sm"
    },
    model: {
      value: _vm.filtroSistemaFim,
      callback: function callback($$v) {
        _vm.filtroSistemaFim = $$v;
      },
      expression: "filtroSistemaFim"
    }
  })], 1), _c('div', {
    staticClass: "sistema-filtros__campo-largo"
  }, [_c('label', {
    staticStyle: {
      "font-size": "9px",
      "margin-bottom": "1px",
      "color": "#555"
    }
  }, [_vm._v("Descrição / histórico")]), _c('b-form-input', {
    staticStyle: {
      "font-size": "11px"
    },
    attrs: {
      "placeholder": "Ex.: frete, aluguel...",
      "size": "sm"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.fetchLancamentosSistema.apply(null, arguments);
      }
    },
    model: {
      value: _vm.filtroSistemaDescricao,
      callback: function callback($$v) {
        _vm.filtroSistemaDescricao = typeof $$v === 'string' ? $$v.trim() : $$v;
      },
      expression: "filtroSistemaDescricao"
    }
  })], 1), _c('div', [_c('label', {
    staticStyle: {
      "font-size": "9px",
      "margin-bottom": "1px",
      "color": "#555"
    }
  }, [_vm._v("Documento")]), _c('b-form-input', {
    staticStyle: {
      "font-size": "11px"
    },
    attrs: {
      "placeholder": "Número do documento",
      "size": "sm"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.fetchLancamentosSistema.apply(null, arguments);
      }
    },
    model: {
      value: _vm.filtroSistemaDocumento,
      callback: function callback($$v) {
        _vm.filtroSistemaDocumento = typeof $$v === 'string' ? $$v.trim() : $$v;
      },
      expression: "filtroSistemaDocumento"
    }
  })], 1), _c('div', {
    staticClass: "sistema-filtros__campo-largo"
  }, [_c('label', {
    staticStyle: {
      "font-size": "9px",
      "margin-bottom": "1px",
      "color": "#555"
    }
  }, [_vm._v(" " + _vm._s(_vm.filtroSistemaTipo === "pagar" ? "Fornecedor" : _vm.filtroSistemaTipo === "receber" ? "Cliente" : "Fornecedor / cliente") + " ")]), _c('b-form-input', {
    staticStyle: {
      "font-size": "11px"
    },
    attrs: {
      "placeholder": _vm.filtroSistemaTipo === 'pagar' ? 'Nome ou CNPJ/CPF do fornecedor' : _vm.filtroSistemaTipo === 'receber' ? 'Nome ou CNPJ/CPF do cliente' : 'Nome ou CNPJ/CPF',
      "size": "sm"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.fetchLancamentosSistema.apply(null, arguments);
      }
    },
    model: {
      value: _vm.filtroSistemaPessoa,
      callback: function callback($$v) {
        _vm.filtroSistemaPessoa = typeof $$v === 'string' ? $$v.trim() : $$v;
      },
      expression: "filtroSistemaPessoa"
    }
  })], 1), _c('div', [_c('label', {
    staticStyle: {
      "font-size": "9px",
      "margin-bottom": "1px",
      "color": "#555"
    }
  }, [_vm._v("Valor mínimo")]), _c('b-form-input', {
    staticStyle: {
      "font-size": "11px"
    },
    attrs: {
      "type": "number",
      "min": "0",
      "step": "0.01",
      "placeholder": "0,00",
      "size": "sm"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.fetchLancamentosSistema.apply(null, arguments);
      }
    },
    model: {
      value: _vm.filtroSistemaValorMin,
      callback: function callback($$v) {
        _vm.filtroSistemaValorMin = $$v;
      },
      expression: "filtroSistemaValorMin"
    }
  })], 1), _c('div', [_c('label', {
    staticStyle: {
      "font-size": "9px",
      "margin-bottom": "1px",
      "color": "#555"
    }
  }, [_vm._v("Valor máximo")]), _c('b-form-input', {
    staticStyle: {
      "font-size": "11px"
    },
    attrs: {
      "type": "number",
      "min": "0",
      "step": "0.01",
      "placeholder": "0,00",
      "size": "sm"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.fetchLancamentosSistema.apply(null, arguments);
      }
    },
    model: {
      value: _vm.filtroSistemaValorMax,
      callback: function callback($$v) {
        _vm.filtroSistemaValorMax = $$v;
      },
      expression: "filtroSistemaValorMax"
    }
  })], 1)]), _c('div', {
    staticClass: "d-flex justify-content-end mt-2",
    staticStyle: {
      "gap": "6px"
    }
  }, [_c('button', {
    staticClass: "btn btn-sm btn-outline-secondary",
    staticStyle: {
      "height": "28px",
      "font-size": "11px"
    },
    attrs: {
      "disabled": _vm.isLoadingSistema
    },
    on: {
      "click": _vm.limparFiltrosSistema
    }
  }, [_vm._v(" Limpar ")]), _c('button', {
    staticClass: "btn btn-sm btn-success font-weight-bold",
    staticStyle: {
      "height": "28px",
      "font-size": "11px"
    },
    attrs: {
      "disabled": _vm.isLoadingSistema
    },
    on: {
      "click": _vm.fetchLancamentosSistema
    }
  }, [_vm._v(" Buscar ")])])]) : _vm._e(), _c('div', {
    staticClass: "conc-col-body"
  }, [_vm.isLoadingSistema ? _c('div', {
    staticClass: "text-center py-4"
  }, [_c('b-spinner', {
    attrs: {
      "variant": "primary",
      "small": ""
    }
  }), _c('small', {
    staticClass: "d-block text-muted mt-1"
  }, [_vm._v("Carregando...")])], 1) : _vm._e(), !_vm.isLoadingSistema && _vm.lancamentosSistemaDisponiveis.length === 0 ? _c('div', {
    staticClass: "text-center text-muted py-5"
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("Nenhum lançamento encontrado com os filtros informados.")])]) : _vm._e(), _vm._l(_vm.lancamentosSistemaVisiveis, function (lan, idx) {
    return _c('div', {
      key: 'sis-' + (lan.id || idx),
      staticClass: "sistema-card",
      class: {
        'sistema-card--over': _vm.dropTargetSistema === lan,
        'sistema-card--conciliado': lan._conciliado
      },
      on: {
        "dragover": function dragover($event) {
          $event.preventDefault();
          _vm.dropTargetSistema = lan;
        },
        "dragleave": function dragleave($event) {
          _vm.dropTargetSistema = null;
        },
        "drop": function drop($event) {
          $event.preventDefault();
          return _vm.onDrop(lan);
        }
      }
    }, [lan._conciliado ? _c('div', {
      staticClass: "sistema-card__match"
    }, [_c('div', {
      staticClass: "d-flex justify-content-between align-items-start"
    }, [_c('div', {
      staticStyle: {
        "flex": "1"
      }
    }, [_c('div', {
      staticClass: "d-flex align-items-center mb-1",
      staticStyle: {
        "gap": "4px"
      }
    }, [_c('span', {
      staticClass: "badge badge-success",
      staticStyle: {
        "font-size": "8px",
        "padding": "2px 4px"
      }
    }, [_vm._v("✓ Conciliado")]), _c('small', {
      staticClass: "text-muted",
      staticStyle: {
        "font-size": "9px"
      }
    }, [_vm._v(_vm._s(_vm.formatDate(lan.data || lan.data_vencimento)))])]), _c('div', {
      staticClass: "font-weight-bold",
      staticStyle: {
        "font-size": "11px"
      }
    }, [_vm._v(_vm._s(lan.historico || lan.descricao))]), lan.pessoa ? _c('div', {
      staticClass: "text-muted",
      staticStyle: {
        "font-size": "9px"
      }
    }, [_vm._v(" " + _vm._s(lan.pessoa.nome)), lan.pessoa.cnpj_cpf ? _c('span', [_vm._v(" • " + _vm._s(lan.pessoa.cnpj_cpf))]) : _vm._e()]) : _vm._e(), lan.data_vencimento ? _c('div', {
      staticClass: "text-muted",
      staticStyle: {
        "font-size": "9px"
      }
    }, [_vm._v(" Venc: "), _c('strong', [_vm._v(_vm._s(_vm.formatDate(lan.data_vencimento)))])]) : _vm._e(), lan.documento ? _c('div', {
      staticClass: "text-muted",
      staticStyle: {
        "font-size": "9px"
      }
    }, [_vm._v(" Doc: "), _c('strong', [_vm._v(_vm._s(lan.documento))])]) : _vm._e(), _c('div', {
      staticClass: "mt-1 p-1 rounded",
      staticStyle: {
        "background": "#f0f9f0",
        "font-size": "9px"
      }
    }, [_c('span', {
      staticClass: "text-muted"
    }, [_vm._v("OFX: ")]), _c('span', {
      staticClass: "font-weight-bold"
    }, [_vm._v(_vm._s(lan._conciliado.memo))]), _c('span', {
      staticClass: "text-muted ml-1"
    }, [_vm._v("(" + _vm._s(_vm.formatDate(lan._conciliado.dtPosted)) + ")")])]), _c('div', {
      staticClass: "mt-1",
      staticStyle: {
        "font-size": "10px"
      }
    }, [_c('label', {
      staticClass: "text-muted",
      staticStyle: {
        "display": "block",
        "margin-bottom": "2px",
        "font-size": "10px"
      }
    }, [_vm._v("Plano de Contas:")]), _c('div', {
      staticClass: "plano-contas-typeahead"
    }, [_c('b-form-input', {
      ref: 'planoInput' + lan.id,
      refInFor: true,
      attrs: {
        "value": _vm.planoContasBuscaAtual[lan.id] || _vm.getPlanoContaDescricao(lan),
        "autocomplete": "off",
        "placeholder": "Buscar plano de contas...",
        "size": "sm"
      },
      on: {
        "input": function input(val) {
          return _vm.onPlanoContasBuscaInput(lan, val);
        },
        "focus": function focus(e) {
          _vm.lancamentoEditando = lan;
          _vm.$nextTick(function () {
            e.target.select();
          });
          _vm.onPlanoContasBuscaInput(lan, '');
        }
      }
    }), _vm.planoContasDropdownAbertoId === lan.id && _vm.planosContasFiltrados[lan.id] && _vm.planosContasFiltrados[lan.id].length > 0 ? _c('div', {
      staticClass: "plano-contas-dropdown"
    }, _vm._l(_vm.planosContasFiltrados[lan.id].slice(0, 10), function (p) {
      return _c('div', {
        key: p.id,
        staticClass: "plano-contas-option",
        on: {
          "mousedown": function mousedown($event) {
            $event.preventDefault();
            return function () {
              _vm.alterarPlanoConta(lan, p.id);
              _vm.$set(_vm.planoContasBuscaAtual, lan.id, p.descricao);
              _vm.fecharDropdownPlanoContas(lan.id);
            }.apply(null, arguments);
          }
        }
      }, [_c('span', {
        staticClass: "font-weight-bold",
        staticStyle: {
          "font-size": "12px"
        }
      }, [_vm._v(_vm._s(p.descricao))])]);
    }), 0) : _vm._e(), _vm.planoContasDropdownAbertoId === lan.id && _vm.planoContasBuscaAtual[lan.id] && (!_vm.planosContasFiltrados[lan.id] || _vm.planosContasFiltrados[lan.id].length === 0) ? _c('div', {
      staticClass: "plano-contas-dropdown"
    }, [_c('div', {
      staticClass: "plano-contas-empty"
    }, [_vm._v("Nenhum plano encontrado.")])]) : _vm._e()], 1)])]), _c('div', {
      staticClass: "text-right ml-2"
    }, [_c('div', {
      staticClass: "font-weight-bolder",
      class: _vm.getValorClassPorTipo(lan.tipo),
      staticStyle: {
        "font-size": "12px",
        "white-space": "nowrap"
      }
    }, [_vm._v(" R$ " + _vm._s(_vm.numberToReal(Math.abs(lan.valor), 2)) + " ")]), _c('button', {
      staticClass: "btn btn-xs btn-link text-danger p-0 mt-1",
      staticStyle: {
        "font-size": "8px"
      },
      on: {
        "click": function click($event) {
          return _vm.desfazerConciliacao(lan);
        }
      }
    }, [_vm._v(" Desfazer ")])])])]) : _c('div', [_c('div', {
      staticClass: "d-flex justify-content-between align-items-center"
    }, [_c('div', {
      staticStyle: {
        "flex": "1",
        "min-width": "0"
      }
    }, [_c('div', {
      staticClass: "d-flex align-items-center gap-1 mb-1"
    }, [_c('small', {
      staticClass: "text-muted",
      staticStyle: {
        "font-size": "9px"
      }
    }, [_vm._v(_vm._s(_vm.formatDate(lan.data || lan.data_vencimento)))]), lan._sugeridoOfx ? _c('span', {
      staticClass: "badge badge-warning",
      staticStyle: {
        "font-size": "7px",
        "padding": "2px 4px"
      }
    }, [_vm._v(" ✓ Sugerido ")]) : _vm._e()]), _c('div', {
      staticClass: "font-weight-bold mt-1",
      staticStyle: {
        "font-size": "11px"
      }
    }, [_vm._v(_vm._s(lan.historico || lan.descricao))]), _c('div', {
      staticClass: "d-flex align-items-center",
      staticStyle: {
        "gap": "6px"
      }
    }, [_c('small', {
      staticClass: "text-muted",
      staticStyle: {
        "font-size": "9px"
      }
    }, [_vm._v(_vm._s(lan.tipo || ""))]), lan.situacao ? _c('small', {
      staticClass: "text-muted",
      staticStyle: {
        "font-size": "9px"
      }
    }, [_vm._v(" • " + _vm._s(lan.situacao === "baixado" ? "Baixado" : "Em aberto") + " ")]) : _vm._e(), lan.data_vencimento ? _c('small', {
      staticClass: "text-muted",
      staticStyle: {
        "font-size": "9px"
      }
    }, [_vm._v(" • Venc: "), _c('strong', [_vm._v(_vm._s(_vm.formatDate(lan.data_vencimento)))])]) : _vm._e()]), lan.pessoa ? _c('div', {
      staticClass: "text-muted",
      staticStyle: {
        "font-size": "9px",
        "margin-top": "2px"
      }
    }, [_vm._v(" " + _vm._s(lan.pessoa.nome)), lan.pessoa.cnpj_cpf ? _c('span', [_vm._v(" • " + _vm._s(lan.pessoa.cnpj_cpf))]) : _vm._e()]) : _vm._e(), lan.documento ? _c('div', {
      staticClass: "text-muted",
      staticStyle: {
        "font-size": "9px",
        "margin-top": "2px"
      }
    }, [_vm._v(" Doc: "), _c('strong', [_vm._v(_vm._s(lan.documento))])]) : _vm._e(), lan._sugeridoOfx ? _c('div', {
      staticClass: "mt-1",
      staticStyle: {
        "font-size": "8px"
      }
    }, [_c('small', {
      staticClass: "badge badge-light"
    }, [_vm._v(" Corresponde a OFX: " + _vm._s(lan._sugeridoOfx) + " (" + _vm._s(Math.round(lan._confiancaSugestaoOfx * 100)) + ") ")])]) : _vm._e(), _c('div', {
      staticClass: "mt-1",
      staticStyle: {
        "font-size": "10px"
      }
    }, [_c('label', {
      staticClass: "text-muted",
      staticStyle: {
        "display": "block",
        "margin-bottom": "2px",
        "font-size": "10px"
      }
    }, [_vm._v("Plano de Contas:")]), _c('div', {
      staticClass: "plano-contas-typeahead"
    }, [_c('b-form-input', {
      ref: 'planoInput' + lan.id,
      refInFor: true,
      attrs: {
        "value": _vm.planoContasBuscaAtual[lan.id] || _vm.getPlanoContaDescricao(lan),
        "autocomplete": "off",
        "placeholder": "Buscar plano de contas...",
        "size": "sm"
      },
      on: {
        "input": function input(val) {
          return _vm.onPlanoContasBuscaInput(lan, val);
        },
        "focus": function focus(e) {
          _vm.lancamentoEditando = lan;
          _vm.$nextTick(function () {
            e.target.select();
          });
          _vm.onPlanoContasBuscaInput(lan, '');
        }
      }
    }), _vm.planoContasDropdownAbertoId === lan.id && _vm.planosContasFiltrados[lan.id] && _vm.planosContasFiltrados[lan.id].length > 0 ? _c('div', {
      staticClass: "plano-contas-dropdown"
    }, _vm._l(_vm.planosContasFiltrados[lan.id].slice(0, 10), function (p) {
      return _c('div', {
        key: p.id,
        staticClass: "plano-contas-option",
        on: {
          "mousedown": function mousedown($event) {
            $event.preventDefault();
            return function () {
              _vm.alterarPlanoConta(lan, p.id);
              _vm.$set(_vm.planoContasBuscaAtual, lan.id, p.descricao);
              _vm.fecharDropdownPlanoContas(lan.id);
            }.apply(null, arguments);
          }
        }
      }, [_c('span', {
        staticClass: "font-weight-bold",
        staticStyle: {
          "font-size": "12px"
        }
      }, [_vm._v(_vm._s(p.descricao))])]);
    }), 0) : _vm._e(), _vm.planoContasDropdownAbertoId === lan.id && _vm.planoContasBuscaAtual[lan.id] && (!_vm.planosContasFiltrados[lan.id] || _vm.planosContasFiltrados[lan.id].length === 0) ? _c('div', {
      staticClass: "plano-contas-dropdown"
    }, [_c('div', {
      staticClass: "plano-contas-empty"
    }, [_vm._v("Nenhum plano encontrado.")])]) : _vm._e()], 1)])]), _c('div', {
      staticClass: "font-weight-bolder ml-2",
      class: _vm.getValorClassPorTipo(lan.tipo),
      staticStyle: {
        "font-size": "12px",
        "white-space": "nowrap"
      }
    }, [_vm._v(" R$ " + _vm._s(_vm.numberToReal(Math.abs(lan.valor), 2)) + " ")])]), _vm.dropTargetSistema === lan ? _c('div', {
      staticClass: "sistema-card__drop-hint"
    }, [_c('ArrowDownBold', {
      staticClass: "mr-1",
      attrs: {
        "size": 12
      }
    }), _vm._v(" Solte aqui para conciliar ")], 1) : _vm._e()])]);
  }), _vm.lancamentosSistemaVisiveis.length < _vm.lancamentosSistemaDisponiveis.length ? _c('button', {
    staticClass: "btn btn-sm btn-light-success font-weight-bold mt-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.carregarMaisSistema
    }
  }, [_vm._v(" Mostrar mais " + _vm._s(Math.min(_vm.LOTE_RENDERIZACAO, _vm.lancamentosSistemaDisponiveis.length - _vm.lancamentosSistemaVisiveis.length)) + " ")]) : _vm._e()], 2)])]), _vm.conciliadosCount > 0 ? _c('div', {
    staticClass: "mt-4"
  }, [_c('div', {
    staticClass: "text-muted font-weight-bold cursor-pointer mb-2",
    staticStyle: {
      "font-size": "13px"
    },
    on: {
      "click": function click($event) {
        _vm.showConciliados = !_vm.showConciliados;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.showConciliados ? '▼' : '▶') + " " + _vm._s(_vm.conciliadosCount) + " par(es) conciliado(s) ")]), _vm.showConciliados ? _c('div', {
    staticClass: "conciliados-list"
  }, [_vm._l(_vm.paresConciliadosVisiveis, function (par, idx) {
    return _c('div', {
      key: 'par-' + (par.ofx.fitId || idx) + '-' + (par.sistema.id || idx),
      staticClass: "conciliado-row"
    }, [_c('div', {
      staticClass: "conciliado-row__ofx"
    }, [_c('small', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(_vm.formatDate(par.ofx.dtPosted)))]), _c('div', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(par.ofx.memo))]), _c('span', {
      staticClass: "font-weight-bold",
      class: par.ofx.trnAmt >= 0 ? 'text-success' : 'text-danger',
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v("R$ " + _vm._s(_vm.numberToReal(Math.abs(par.ofx.trnAmt), 2)))])]), _c('div', {
      staticClass: "conciliado-row__arrow"
    }, [_vm._v("⟺")]), _c('div', {
      staticClass: "conciliado-row__sis"
    }, [_c('small', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(_vm.formatDate(par.sistema.data)))]), _c('div', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(par.sistema.descricao))]), _c('span', {
      staticClass: "font-weight-bold",
      class: _vm.getValorClassPorTipo(par.sistema.tipo),
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v("R$ " + _vm._s(_vm.numberToReal(Math.abs(par.sistema.valor), 2)))])]), _c('button', {
      staticClass: "btn btn-xs btn-outline-danger ml-2",
      staticStyle: {
        "white-space": "nowrap",
        "height": "28px"
      },
      on: {
        "click": function click($event) {
          return _vm.desfazerPar(par);
        }
      }
    }, [_vm._v("Desfazer")])]);
  }), _vm.paresConciliadosVisiveis.length < _vm.paresConciliados.length ? _c('button', {
    staticClass: "btn btn-sm btn-light-primary font-weight-bold mt-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.carregarMaisConciliados
    }
  }, [_vm._v(" Mostrar mais " + _vm._s(Math.min(_vm.LOTE_RENDERIZACAO, _vm.paresConciliados.length - _vm.paresConciliadosVisiveis.length)) + " ")]) : _vm._e()], 2) : _vm._e()]) : _vm._e()])], 1)], 1), _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('router-link', {
    staticClass: "btn btn-clean font-weight-bold",
    attrs: {
      "to": {
        name: 'conciliacaoBancariaLista'
      }
    }
  }, [_vm._v(" Voltar ")])], 1)])])]), _c('b-modal', {
    attrs: {
      "id": "modal-novo-lancamento-create",
      "title": "Criar Lançamento Financeiro",
      "cancel-title": "Cancelar",
      "busy": _vm.isConfirmandoLancamento,
      "ok-disabled": _vm.isConfirmandoLancamento
    },
    on: {
      "ok": _vm.confirmarNovoLancamento,
      "cancel": function cancel($event) {
        _vm.trnSelecionada = null;
      }
    },
    scopedSlots: _vm._u([{
      key: "modal-ok",
      fn: function fn() {
        return [_vm.isConfirmandoLancamento ? _c('b-spinner', {
          staticClass: "mr-1",
          attrs: {
            "small": ""
          }
        }) : _vm._e(), _vm._v(" " + _vm._s(_vm.isConfirmandoLancamento ? 'Salvando...' : 'Confirmar') + " ")];
      },
      proxy: true
    }])
  }, [_vm.trnSelecionada ? _c('b-form', [_c('b-row', {
    staticClass: "mb-3"
  }, [_c('b-col', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Tipo:")]), _c('span', {
    staticClass: "badge",
    class: _vm.novoLancamento.tipo === 'E' ? 'badge-success' : 'badge-danger',
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v(" " + _vm._s(_vm.novoLancamento.tipo === 'E' ? 'Receita' : 'Despesa') + " ")])])], 1), _c('b-form-group', {
    attrs: {
      "label": "Descrição",
      "label-for": "nl-descricao"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "nl-descricao",
      "placeholder": "Descrição do lançamento"
    },
    model: {
      value: _vm.novoLancamento.descricao,
      callback: function callback($$v) {
        _vm.$set(_vm.novoLancamento, "descricao", $$v);
      },
      expression: "novoLancamento.descricao"
    }
  })], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Data",
      "label-for": "nl-data"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "nl-data",
      "type": "date"
    },
    model: {
      value: _vm.novoLancamento.data,
      callback: function callback($$v) {
        _vm.$set(_vm.novoLancamento, "data", $$v);
      },
      expression: "novoLancamento.data"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Valor (R$)",
      "label-for": "nl-valor"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "nl-valor",
      "type": "number",
      "step": "0.01",
      "min": "0"
    },
    model: {
      value: _vm.novoLancamento.valor,
      callback: function callback($$v) {
        _vm.$set(_vm.novoLancamento, "valor", $$v);
      },
      expression: "novoLancamento.valor"
    }
  })], 1)], 1)], 1), _vm.novoLancamento.tipo === 'S' ? _c('b-form-group', {
    attrs: {
      "label": "Fornecedor",
      "label-for": "nl-fornecedor"
    }
  }, [_c('div', {
    directives: [{
      def: ClickOutside,
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.fecharDropdownFornecedor,
      expression: "fecharDropdownFornecedor"
    }],
    staticClass: "fornecedor-typeahead-modal"
  }, [_c('b-form-input', {
    attrs: {
      "id": "nl-fornecedor",
      "autocomplete": "off",
      "placeholder": "Buscar fornecedor..."
    },
    on: {
      "input": _vm.onFornecedorBuscaInput,
      "focus": function focus($event) {
        _vm.fornecedorDropdownAberto = true;
      }
    },
    model: {
      value: _vm.fornecedorBusca,
      callback: function callback($$v) {
        _vm.fornecedorBusca = $$v;
      },
      expression: "fornecedorBusca"
    }
  }), _vm.fornecedorDropdownAberto && _vm.fornecedores.length > 0 ? _c('div', {
    staticClass: "plano-contas-dropdown"
  }, _vm._l(_vm.fornecedores.slice(0, 10), function (f) {
    return _c('div', {
      key: f.id_pessoa,
      staticClass: "plano-contas-option",
      on: {
        "mousedown": function mousedown($event) {
          $event.preventDefault();
          return _vm.selecionarFornecedor(f);
        }
      }
    }, [_c('div', {
      staticClass: "d-flex justify-content-between"
    }, [_c('span', {
      staticClass: "font-weight-bold",
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(f.nome))]), _c('span', {
      staticClass: "text-muted",
      staticStyle: {
        "font-size": "10px"
      }
    }, [_vm._v(_vm._s(f.cnpj_cpf))])])]);
  }), 0) : _vm._e(), _vm.fornecedorDropdownAberto && _vm.fornecedorBusca && _vm.fornecedores.length === 0 ? _c('div', {
    staticClass: "plano-contas-dropdown"
  }, [_c('div', {
    staticClass: "plano-contas-empty"
  }, [_vm._v("Nenhum fornecedor encontrado.")])]) : _vm._e()], 1)]) : _vm._e(), _vm.novoLancamento.tipo === 'E' ? _c('b-form-group', {
    attrs: {
      "label": "Cliente",
      "label-for": "nl-cliente"
    }
  }, [_c('div', {
    directives: [{
      def: ClickOutside,
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.fecharDropdownCliente,
      expression: "fecharDropdownCliente"
    }],
    staticClass: "cliente-typeahead-modal"
  }, [_c('b-form-input', {
    attrs: {
      "id": "nl-cliente",
      "autocomplete": "off",
      "placeholder": "Buscar cliente..."
    },
    on: {
      "input": _vm.onClienteBuscaInput,
      "focus": function focus($event) {
        _vm.clienteDropdownAberto = true;
      }
    },
    model: {
      value: _vm.clienteBusca,
      callback: function callback($$v) {
        _vm.clienteBusca = $$v;
      },
      expression: "clienteBusca"
    }
  }), _vm.clienteDropdownAberto && _vm.clientes.length > 0 ? _c('div', {
    staticClass: "plano-contas-dropdown"
  }, _vm._l(_vm.clientes.slice(0, 10), function (c) {
    return _c('div', {
      key: c.id_pessoa,
      staticClass: "plano-contas-option",
      on: {
        "mousedown": function mousedown($event) {
          $event.preventDefault();
          return _vm.selecionarCliente(c);
        }
      }
    }, [_c('div', {
      staticClass: "d-flex justify-content-between"
    }, [_c('span', {
      staticClass: "font-weight-bold",
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(c.nome))]), _c('span', {
      staticClass: "text-muted",
      staticStyle: {
        "font-size": "10px"
      }
    }, [_vm._v(_vm._s(c.cnpj_cpf))])])]);
  }), 0) : _vm._e(), _vm.clienteDropdownAberto && _vm.clienteBusca && _vm.clientes.length === 0 ? _c('div', {
    staticClass: "plano-contas-dropdown"
  }, [_c('div', {
    staticClass: "plano-contas-empty"
  }, [_vm._v("Nenhum cliente encontrado.")])]) : _vm._e()], 1)]) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label": "Plano de Contas",
      "label-for": "nl-plano",
      "required": ""
    }
  }, [_c('div', {
    directives: [{
      def: ClickOutside,
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.fecharDropdownPlanoContasModal,
      expression: "fecharDropdownPlanoContasModal"
    }],
    staticClass: "plano-contas-typeahead-modal"
  }, [_c('b-form-input', {
    attrs: {
      "id": "nl-plano",
      "autocomplete": "off",
      "placeholder": "Buscar ou selecionar plano de contas...",
      "state": _vm.novoLancamento.id_plano_contas ? true : null
    },
    on: {
      "input": _vm.onPlanoContasModalBuscaInput,
      "focus": function focus($event) {
        _vm.planoContasModalDropdownAberto = true;
      }
    },
    model: {
      value: _vm.planoContasModalBusca,
      callback: function callback($$v) {
        _vm.planoContasModalBusca = $$v;
      },
      expression: "planoContasModalBusca"
    }
  }), _vm.planoContasModalDropdownAberto && _vm.planosContasModalFiltrados.length > 0 ? _c('div', {
    staticClass: "plano-contas-dropdown"
  }, _vm._l(_vm.planosContasModalFiltrados.slice(0, 10), function (p) {
    return _c('div', {
      key: p.id,
      staticClass: "plano-contas-option",
      on: {
        "mousedown": function mousedown($event) {
          $event.preventDefault();
          return _vm.selecionarPlanoContasModal(p);
        }
      }
    }, [_c('span', {
      staticClass: "font-weight-bold",
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(p.descricao))])]);
  }), 0) : _vm._e(), _vm.planoContasModalDropdownAberto && _vm.planoContasModalBusca && _vm.planosContasModalFiltrados.length === 0 ? _c('div', {
    staticClass: "plano-contas-dropdown"
  }, [_c('div', {
    staticClass: "plano-contas-empty"
  }, [_vm._v("Nenhum plano encontrado.")])]) : _vm._e(), _c('b-form-invalid-feedback', {
    attrs: {
      "state": _vm.novoLancamento.id_plano_contas ? true : null
    }
  }, [_vm._v(" Selecione um plano de contas. ")])], 1)]), _vm.novoLancamento.tipo === 'S' ? _c('CentroCustoSelect', {
    model: {
      value: _vm.novoLancamento.id_centro_custo,
      callback: function callback($$v) {
        _vm.$set(_vm.novoLancamento, "id_centro_custo", $$v);
      },
      expression: "novoLancamento.id_centro_custo"
    }
  }) : _vm._e()], 1) : _vm._e()], 1), _c('b-modal', {
    attrs: {
      "id": "modal-lancamentos-em-massa",
      "title": "Criar Lançamentos em Massa",
      "cancel-title": "Cancelar",
      "busy": _vm.isConfirmandoLancamentosEmMassa,
      "ok-disabled": _vm.isConfirmandoLancamentosEmMassa || !_vm.idPlanoContasMassa
    },
    on: {
      "ok": _vm.confirmarLancamentosEmMassa
    },
    scopedSlots: _vm._u([{
      key: "modal-ok",
      fn: function fn() {
        return [_vm.isConfirmandoLancamentosEmMassa ? _c('b-spinner', {
          staticClass: "mr-1",
          attrs: {
            "small": ""
          }
        }) : _vm._e(), _vm._v(" " + _vm._s(_vm.isConfirmandoLancamentosEmMassa ? 'Criando...' : 'Criar lançamentos') + " ")];
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "lancamentos-massa-resumo mb-4"
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.selecionadosEmMassa.length))]), _vm._v(" lançamento(ões) de "), _c('strong', [_vm._v(_vm._s(_vm.tipoSelecionadoEmMassa === 'E' ? 'receita' : 'despesa'))])]), _c('div', {
    staticClass: "font-weight-bolder",
    class: _vm.tipoSelecionadoEmMassa === 'E' ? 'text-success' : 'text-danger'
  }, [_vm._v(" Total: R$ " + _vm._s(_vm.numberToReal(_vm.totalSelecionadoEmMassa, 2)) + " ")])]), _vm.tipoSelecionadoEmMassa === 'S' ? _c('b-form-group', {
    attrs: {
      "label": "Fornecedor",
      "label-for": "fornecedor-massa"
    }
  }, [_c('div', {
    directives: [{
      def: ClickOutside,
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.fecharDropdownFornecedorMassa,
      expression: "fecharDropdownFornecedorMassa"
    }],
    staticClass: "fornecedor-typeahead-modal"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('b-form-input', {
    attrs: {
      "id": "fornecedor-massa",
      "autocomplete": "off",
      "placeholder": "Buscar fornecedor..."
    },
    on: {
      "input": _vm.onFornecedorMassaBuscaInput,
      "focus": function focus($event) {
        _vm.fornecedorMassaDropdownAberto = true;
      }
    },
    model: {
      value: _vm.fornecedorMassaBusca,
      callback: function callback($$v) {
        _vm.fornecedorMassaBusca = $$v;
      },
      expression: "fornecedorMassaBusca"
    }
  }), _vm.idFornecedorMassa ? _c('div', {
    staticClass: "input-group-append"
  }, [_c('button', {
    staticClass: "btn btn-outline-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.limparFornecedorMassa
    }
  }, [_vm._v(" ✕ ")])]) : _vm._e()], 1), _vm.fornecedorMassaDropdownAberto && _vm.fornecedoresMassa.length > 0 ? _c('div', {
    staticClass: "plano-contas-dropdown"
  }, _vm._l(_vm.fornecedoresMassa.slice(0, 10), function (fornecedor) {
    return _c('div', {
      key: fornecedor.id_pessoa,
      staticClass: "plano-contas-option",
      on: {
        "mousedown": function mousedown($event) {
          $event.preventDefault();
          return _vm.selecionarFornecedorMassa(fornecedor);
        }
      }
    }, [_c('div', {
      staticClass: "d-flex justify-content-between"
    }, [_c('span', {
      staticClass: "font-weight-bold",
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(fornecedor.nome))]), _c('span', {
      staticClass: "text-muted",
      staticStyle: {
        "font-size": "10px"
      }
    }, [_vm._v(_vm._s(fornecedor.cnpj_cpf))])])]);
  }), 0) : _vm._e(), _vm.fornecedorMassaDropdownAberto && _vm.fornecedorMassaBusca && _vm.fornecedoresMassa.length === 0 ? _c('div', {
    staticClass: "plano-contas-dropdown"
  }, [_c('div', {
    staticClass: "plano-contas-empty"
  }, [_vm._v("Nenhum fornecedor encontrado.")])]) : _vm._e()]), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("Opcional. Será aplicado a todos os lançamentos selecionados.")])]) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label": "Plano de Contas",
      "label-for": "plano-contas-massa",
      "required": ""
    }
  }, [_c('div', {
    directives: [{
      def: ClickOutside,
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.fecharDropdownPlanoContasMassa,
      expression: "fecharDropdownPlanoContasMassa"
    }],
    staticClass: "plano-contas-typeahead-modal"
  }, [_c('b-form-input', {
    attrs: {
      "id": "plano-contas-massa",
      "autocomplete": "off",
      "placeholder": "Buscar ou selecionar plano de contas...",
      "state": _vm.idPlanoContasMassa ? true : null
    },
    on: {
      "input": _vm.onPlanoContasMassaBuscaInput,
      "focus": function focus($event) {
        _vm.planoContasMassaDropdownAberto = true;
      }
    },
    model: {
      value: _vm.planoContasMassaBusca,
      callback: function callback($$v) {
        _vm.planoContasMassaBusca = $$v;
      },
      expression: "planoContasMassaBusca"
    }
  }), _vm.planoContasMassaDropdownAberto && _vm.planosContasMassaFiltrados.length > 0 ? _c('div', {
    staticClass: "plano-contas-dropdown"
  }, _vm._l(_vm.planosContasMassaFiltrados.slice(0, 10), function (plano) {
    return _c('div', {
      key: plano.id,
      staticClass: "plano-contas-option",
      on: {
        "mousedown": function mousedown($event) {
          $event.preventDefault();
          return _vm.selecionarPlanoContasMassa(plano);
        }
      }
    }, [_c('span', {
      staticClass: "font-weight-bold",
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(plano.descricao))])]);
  }), 0) : _vm._e(), _vm.planoContasMassaDropdownAberto && _vm.planoContasMassaBusca && _vm.planosContasMassaFiltrados.length === 0 ? _c('div', {
    staticClass: "plano-contas-dropdown"
  }, [_c('div', {
    staticClass: "plano-contas-empty"
  }, [_vm._v("Nenhum plano encontrado.")])]) : _vm._e(), _c('b-form-invalid-feedback', {
    attrs: {
      "state": _vm.idPlanoContasMassa ? true : null
    }
  }, [_vm._v(" Selecione um plano de contas. ")])], 1)]), _vm.tipoSelecionadoEmMassa === 'S' ? _c('CentroCustoSelect', {
    model: {
      value: _vm.idCentroCustoMassa,
      callback: function callback($$v) {
        _vm.idCentroCustoMassa = $$v;
      },
      expression: "idCentroCustoMassa"
    }
  }) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };